import Dropdown from './dropdown';
import DropdownButton from './dropdown-button';

Dropdown.Button = DropdownButton;
export default Dropdown;



// WEBPACK FOOTER //
// ./_antd1.11.2/dropdown/index.jsx